import { Button, Layout, Space } from 'antd';
import React, { useCallback, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import FooterView from '../../layouts/MainLayout/FooterView';
import ThankYouImg from '../../../assets/images/thank_you_images.png';
import { AppDispatch } from '../../../store/app';
import { useDispatch } from 'react-redux';
import { updateAsteriskStatus } from '../../../store/NumberManagementSlice';
import LogoComponent from '../../layouts/Components/LogoComponent';

type RouteParams = { provider_id: string } & Record<string, string | undefined>;

const UpdateAsteriskStatus: React.FC<any> = (props) => {
  // const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const { provider_id } = useParams<RouteParams>();

  const updateStatus = useCallback(
    (id: string) => {
      const payload = {
        id: id,
      };
      dispatch(updateAsteriskStatus(payload))
        .then((res: any) => {
          console.log('res', res);
        })
        .catch((error: any) => {
          console.log('error', error);
        });
    },
    [dispatch],
  );

  useEffect(() => {
    if (provider_id) {
      updateStatus(provider_id);
    }
  }, [updateStatus, provider_id]);

  return (
    <>
      <Layout.Header className='main__page__appheader'>
          <div className='appheader__left'>
              <LogoComponent />
          </div>
      </Layout.Header>
      <section
        className="section pagenotfound__section"
        style={{ height: 'calc(100dvh - 80px)' }}
      >
        <img
          src={ThankYouImg}
          alt="Thank you for confirming."
          style={{ width: '90%', maxWidth: '500px', height: 'auto' }}
          className="pb-80"
        />
        <p className="notFoundText text-center">Thank you for confirming that the routing has been carried out.</p>
        <Space
          size="large"
          className="mt-30"
        >
          <Button
            size="large"
            type="primary"
          >
            <Link to={'/'}>Back Home</Link>
          </Button>
        </Space>
      </section>
      <FooterView />
    </>
  );
};

export default UpdateAsteriskStatus;
